import {Stack, Typography} from '@mui/material';
import {ProjectContext} from '@context/ProjectContext';
import {useContext} from 'react';
import {useTranslation} from 'react-i18next';
import {Link} from 'react-router-dom';
import HomeIcon from '@icons/HomeIcon';

export default function HomeButton(props: any) {
	const {t} = useTranslation();
	const {shahadat} = useContext(ProjectContext);
	const isActive = !!props['aria-selected'];

	return (
		<Link to="/" {...props}>
			<Stack direction="column" alignItems="center" spacing={0.5}>
				<HomeIcon active={isActive}/>
				<Typography fontSize={12} sx={{color: shahadat && isActive ? '#000' : undefined}}>
					{t('home')}
				</Typography>
			</Stack>
		</Link>
	);
}
